Controller.$inject = [];

function Controller() {
}

export function HuiPopoverContent() {
    return {
        restrict: 'E',
        scope: {},
        controller: Controller,
        controllerAs: '$huiPopoverContent',
        transclude: true,
        template: `
            <div class="hui-popover-content">
                <ng-transclude class="w-100"></ng-transclude>
            </div>
        `
    };
} 